module.exports = __webpack_public_path__ + "static/media/ka-choice-poster.e37866f8.png";